import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTable,
  CustomTableContainer,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import { CustomStack, SectionWrapper } from '@components/Styles/CommonStyle';
import { PROFILE_GRADE_CONVERTER, PROFILE_WORK_TYPE_CONVERTER } from '@constants/profile';
import { MenuItem, Select, TableBody, TableHead, Typography } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CustomSorting } from '@components/Styles/TableStyle';

import { CustomButton } from '@components/Styles/ButtonStyle';
import { formatPhoneNumber } from '@utils/formatter';
import { theme } from '@components/Styles/theme';
import { useNavigate } from 'react-router-dom';
import CustomCheckbox from '../Input/CustomCheckBox';
import Pagination from '@components/common/Shared/Pagination';

const ProfileListTable = ({
  profileList = [],
  total,
  page,
  limit,
  onMoveDetail,
  isLoading,
  selectedProfiles,
  onSelectProfile,
  onDeleteSelected,
  onSelectAll,
  isAllOnPageSelected,
  handlePageChange,
  handleLimitChange,
  handleOrderByAndOrderDirChange,
  orderBy,
  orderDir
}) => {
  const navigate = useNavigate();

  return (
    <SectionWrapper>
      <CustomStack justifyContent="spaceBetween" mb={2}>
        <Typography sx={theme.typography.h4}>프로필 리스트</Typography>
        <CustomStack direction="row" spacing={1}>
          <CustomButton onClick={() => navigate('/profile/create')}>신규등록</CustomButton>
          <CustomButton color="error" onClick={onDeleteSelected} disabled={selectedProfiles.length === 0}>
            삭제
          </CustomButton>
        </CustomStack>
      </CustomStack>
      <CustomTableContainer>
        <CustomTable>
          <TableHead>
            <CustomTableRow>
              <CustomHeaderCell align="center" width="60px">
                <CustomCheckbox checked={isAllOnPageSelected} onChange={(e) => onSelectAll(e.target.checked)} />
              </CustomHeaderCell>
              <CustomHeaderCell align="center">NO</CustomHeaderCell>
              <CustomHeaderCell align="center">
                성명
                {
                  orderBy === 'person_name' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('person_name', 'DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'person_name' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('person_name', 'ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        handleOrderByAndOrderDirChange('person_name', 'ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                }
              </CustomHeaderCell>
              <CustomHeaderCell align="center">
                직위
                {
                  orderBy === 'position' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('position', 'DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'position' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('position', 'ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        handleOrderByAndOrderDirChange('position', 'ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                }
              </CustomHeaderCell>
              <CustomHeaderCell align="center">
                휴대전화
                {
                  orderBy === 'phone' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('phone', 'DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'phone' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('phone', 'ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        handleOrderByAndOrderDirChange('phone', 'ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                }
              </CustomHeaderCell>
              <CustomHeaderCell align="center">
                이메일
                {
                  orderBy === 'email' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('email', 'DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'email' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('email', 'ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        handleOrderByAndOrderDirChange('email', 'ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                }
              </CustomHeaderCell>
              <CustomHeaderCell align="center">
                경력
                {
                  orderBy === 'workPeriod' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('workPeriod', 'DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'workPeriod' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('workPeriod', 'ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        handleOrderByAndOrderDirChange('workPeriod', 'ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                }
              </CustomHeaderCell>
              <CustomHeaderCell align="center">
                등급
                {
                  orderBy === 'grade' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('grade', 'DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'grade' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('grade', 'ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        handleOrderByAndOrderDirChange('grade', 'ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                }
              </CustomHeaderCell>
              <CustomHeaderCell align="center">
                근무구분
                {
                  orderBy === 'workType' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('workType', 'DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'workType' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('workType', 'ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        handleOrderByAndOrderDirChange('workType', 'ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                }
              </CustomHeaderCell>
              <CustomHeaderCell align="center">
                자격증
                {
                  orderBy === 'license' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('license', 'DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'license' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        handleOrderByAndOrderDirChange('license', 'ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        handleOrderByAndOrderDirChange('license', 'ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                }
              </CustomHeaderCell>
            </CustomTableRow>
          </TableHead>
          {!isLoading && (
            <TableBody>
              {profileList.length > 0 ? (
                profileList.map((profile, index) => (
                  <CustomTableRow
                    hover
                    key={profile.profileId}
                    onClick={(e) => {
                      if (e.target.type === 'checkbox' || e.target.closest('span.MuiCheckbox-root')) {
                        return;
                      }
                      e.preventDefault();
                      onMoveDetail(profile.profileId);
                    }}
                    selected={selectedProfiles.includes(profile.profileId)}
                  >
                    <CustomBodyCell
                      align="center"
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelectProfile(profile.profileId);
                      }}
                      sx={{ cursor: 'pointer' }}
                    >
                      <CustomCheckbox checked={selectedProfiles.includes(profile.profileId)} size="small" />
                    </CustomBodyCell>
                    <CustomBodyCell align="center">{total - ((page - 1) * limit + index)}</CustomBodyCell>
                    <CustomBodyCell align="center">{profile.name}</CustomBodyCell>
                    <CustomBodyCell align="center">{profile.position || '-'}</CustomBodyCell>
                    <CustomBodyCell align="center">{formatPhoneNumber(profile.phone)}</CustomBodyCell>
                    <CustomBodyCell align="center">{profile.email}</CustomBodyCell>
                    <CustomBodyCell align="center">{profile.workPeriod}</CustomBodyCell>
                    <CustomBodyCell align="center">{PROFILE_GRADE_CONVERTER[profile.grade] || '-'}</CustomBodyCell>
                    <CustomBodyCell align="center">
                      {PROFILE_WORK_TYPE_CONVERTER[profile.workType] || '-'}
                    </CustomBodyCell>
                    <CustomBodyCell align="center">{profile.license || '-'}</CustomBodyCell>
                  </CustomTableRow>
                ))
              ) : (
                <CustomTableRow>
                  <CustomBodyCell colSpan={10} align="center">
                    등록된 프로필이 없습니다.
                  </CustomBodyCell>
                </CustomTableRow>
              )}
            </TableBody>
          )}
        </CustomTable>

        <Select
          sx={{ mt: 2, width: '100px', height: '40px' }}
          value={limit}
          onChange={(e) => handleLimitChange(e.target.value)}
        >
          {/* <MenuItem value={1}>1</MenuItem>  */} {/* 테스트용 */}
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={20}>20</MenuItem>
          <MenuItem value={30}>30</MenuItem>
        </Select>

        {total > 0 && (
          <Pagination
            count={Math.ceil(total / limit)}
            page={page}
            onChange={handlePageChange}
          />
        )}
      </CustomTableContainer>
    </SectionWrapper>
  );
};

export default ProfileListTable;
